import { z } from 'zod';
/**
 * Flow Control Path v1 Configuration Validator
 * Path nodes can have optional conditions
 */
export const Flow_Control_Path_1_ConfigValidator = z.object({
    conditions: z.array(z.array(z.any())).optional()
});
//# sourceMappingURL=flow-control-path-1.js.map